import {Pipe, PipeTransform, Injectable} from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'filter',
  pure: false
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: any[], fields: string | string[], value: string | boolean): any[] {
    if (!items) {
      return [];
    }

    if (_.isEmpty(value)) {
      return items;
    }

    return _.filter(items, it => {
      const search = new RegExp(value.toString(), 'ig');

      if (typeof fields === 'string') {
        return search.test(it[fields]);
      }

      if (typeof fields === 'object') {
        let result = false;
        _.forEach(fields, f => result = result || search.test(it[f]));
        return result;
      }
    });
  }
}
